import { render, staticRenderFns } from "./DashboardPatientsEvaluation.vue?vue&type=template&id=50149b4f&lang=pug"
import script from "./DashboardPatientsEvaluation.vue?vue&type=script&lang=js"
export * from "./DashboardPatientsEvaluation.vue?vue&type=script&lang=js"
import style0 from "./DashboardPatientsEvaluation.vue?vue&type=style&index=0&id=50149b4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports